import { render, staticRenderFns } from "./LandingPageNew.vue?vue&type=template&id=e654eba0&scoped=true&"
import script from "./LandingPageNew.vue?vue&type=script&lang=js&"
export * from "./LandingPageNew.vue?vue&type=script&lang=js&"
import style0 from "./LandingPageNew.vue?vue&type=style&index=0&id=e654eba0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e654eba0",
  null
  
)

export default component.exports